export const DOWNLOAD_SALES_CHALLENGE_REPORT_REQUEST = 'DOWNLOAD_SALES_CHALLENGE_REPORT_REQUEST';
export const DOWNLOAD_SALES_CHALLENGE_REPORT_SUCCESS = 'DOWNLOAD_SALES_CHALLENGE_REPORT_SUCCESS';
export const DOWNLOAD_SALES_CHALLENGE_REPORT_FAIL = 'DOWNLOAD_SALES_CHALLENGE_REPORT_FAIL';

export function downloadSalesChallengeReportRequest(payload) {
  return {
    type: DOWNLOAD_SALES_CHALLENGE_REPORT_REQUEST,
    payload: {
      ...payload,

      ...payload.params,

      fileConfig: {
        extension: 'xlsx',
        contentType:
          'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    },
  };
}

export function downloadSalesChallengeReportSuccess(payload) {
  return { type: DOWNLOAD_SALES_CHALLENGE_REPORT_SUCCESS, payload };
}

export function downloadSalesChallengeReportFail(payload) {
  return { type: DOWNLOAD_SALES_CHALLENGE_REPORT_FAIL, payload };
}
